import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { theme } from './styles/theme';
import HeroSection from './components/HeroSection/HeroSection';
import GameSection from './components/GameSection/GameSection';
import CharacterSection from './components/CharacterSection/CharacterSection';
import FraudBusterSection from './components/FraudBusterSection/FraudBusterSection';
import DownloadSection from './components/DownloadSection/DownloadSection';
import LazyLoad from './components/LazyLoad';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.fonts.main};
    color: ${theme.colors.text.primary};
    background: ${theme.colors.white};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    line-height: 1.2;
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    html {
      font-size: 14px;
    }
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  overflow-x: hidden;
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <AppContainer>
        {/* 最初に表示される重要なコンテンツは即座に読み込み */}
        <HeroSection />
        
        {/* ゲームセクション - ユーザーがスクロールしたときに読み込み */}
        <LazyLoad rootMargin="300px">
          <GameSection />
        </LazyLoad>
        
        {/* キャラクターセクション - 遊び方 */}
        <LazyLoad rootMargin="200px">
          <CharacterSection />
        </LazyLoad>
        
        {/* 詐欺バスターセクション */}
        <LazyLoad rootMargin="200px">
          <FraudBusterSection />
        </LazyLoad>
        
        {/* ダウンロードセクション */}
        <LazyLoad rootMargin="100px">
          <DownloadSection />
        </LazyLoad>
      </AppContainer>
    </>
  );
}

export default App;